/* DON'T EDIT THIS FILE: edit original and run build again */ import { alerter } from "../../framework/alert/alert.tsx";
import { VerifyEmailWithTokenCallError } from "../../framework/auth-verify-email-token-call/verify-email-with-token-call-signature.ts";
import { ErrorMessageDescription } from "../../framework/default-error-message/default-error-message.tsx";
import { MessageBuilderType } from "../../framework/default-error-message/message-builder-type.ts";
import { TokenError } from "../../framework/token/token-error-codes.ts";

const inputTokenErrors: Record<
  VerifyEmailWithTokenCallError | TokenError,
  {
    builder?: MessageBuilderType;
    code?: VerifyEmailWithTokenCallError | TokenError;
  }
> = {
  [TokenError.noActiveToken]: {
    builder: { message: "El token ya no está activo." },
    code: TokenError.noActiveToken,
  },
  [TokenError.notFound]: {
    builder: { message: "El usuario o token ingresado es inválido." },
    code: TokenError.notFound,
  },
  [TokenError.expired]: {
    builder: { message: "El token ingresado caducó." },
    code: TokenError.expired,
  },
  [TokenError.unsupported]: {
    builder: { message: "El token ingresado no es el esperado." },
    code: TokenError.unsupported,
  },
  [VerifyEmailWithTokenCallError.internalError]: {
    builder: { message: "Error interno." },
    code: VerifyEmailWithTokenCallError.internalError,
  },
};

export const onEmailVerificationViaTokenInputTokenError = async (
  error: VerifyEmailWithTokenCallError | TokenError
): Promise<void> => {
  const params = inputTokenErrors[error] ?? {
    builder: { message: "Ha ocurrido un error. " },
    code: "Error interno",
  };
  await alerter.alert(<ErrorMessageDescription {...params} />);
};
